import React, { useState, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { ThreeDots } from "react-loader-spinner";
import { FiLogOut } from "react-icons/fi";
import { ChevronRight } from "lucide-react";
import { links } from "./data/dummy";
import { useStateCotext } from "../../Context/ContextProvider";
import { AuthContext } from "../../Context/AuthContextProvider";
import logo2 from "../media/gold-logo2.png";

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } =
    useStateCotext();
  const { isAuth, logoutme, loginUser } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let handleClick2 = async () => {
    setIsLoading(true);
    if (isAuth === true) {
      await logoutme({ email: loginUser.email_id });
      navigate("/Login");
      handleClose();
    } else {
      navigate("/Login");
    }
    setIsLoading(false);
  };

  const activeLink =
    "flex items-center gap-2.5 pl-4 pr-3 py-2.5 rounded-xl text-white text-[14px] font-semibold mx-3 my-0.5 bg-gradient-to-r from-[#b99653] to-[#d4af37] shadow-md transform transition-all duration-200";

  const normalLink =
    "flex items-center gap-2.5 pl-4 pr-3 py-2.5 rounded-xl text-[14px] font-medium text-gray-700 hover:bg-gradient-to-r hover:from-[#fcdb6a]/20 hover:to-[#b99653]/10 mx-3 my-0.5 transition-all duration-200 group";

  return (
    <div className="h-screen flex flex-col bg-gradient-to-b from-white via-blue-50/30 to-indigo-50/30 border-r border-gray-200 shadow-lg">
      {activeMenu && (
        <>
          {/* Header Section */}
          <div className="flex-shrink-0">
            <div className="flex items-center justify-between h-20 px-4 py-4 bg-gradient-to-r from-[#101c4c] to-[#1a2d5c]">
              <Link
                to="/"
                onClick={handleCloseSideBar}
                className="flex items-center"
              >
                <img
                  src={logo2}
                  alt="Brand Logo"
                  className="h-12 w-auto object-contain transition-transform duration-200 hover:scale-105"
                />
              </Link>
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                className="text-white text-2xl p-2 rounded-full hover:bg-white/10 transition-all duration-200 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </div>

            {/* User Info Card */}
            {loginUser && loginUser.username && (
              <div className="mx-3 my-4">
                <div className="bg-white rounded-xl shadow-sm overflow-hidden h-20">
                  <div className="h-full flex items-center gap-3 px-4">
                    {/* Avatar */}
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#b99653] to-[#d4af37] flex items-center justify-center text-white font-bold text-xl shadow-md flex-shrink-0 ring-2 ring-[#b99653]/20">
                      {loginUser.firstName?.[0]?.toUpperCase() ||
                        loginUser.username?.[0]?.toUpperCase() ||
                        "U"}
                    </div>
                    {/* Text Content */}
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-bold text-gray-900 truncate leading-tight">
                        {loginUser.firstName
                          ? `${loginUser.firstName}${
                              loginUser.lastName ? " " + loginUser.lastName : ""
                            }`
                          : loginUser.username}
                      </h3>
                      <p className="text-xs text-gray-600 truncate mt-0.5">
                        {loginUser.email_id || "member@getbrand.gold"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Navigation Links */}
          <div className="flex-1 overflow-y-auto custom-scrollbar py-1">
            {links.map((item) => (
              <div key={item.title} className="mb-3">
                <div className="px-5 py-2.5 flex items-center gap-2">
                  <div className="h-[2px] w-6 bg-gradient-to-r from-[#b99653] to-transparent rounded-full"></div>
                  <p className="text-[#101c4c] text-[11px] font-bold uppercase tracking-wider">
                    {item.title}
                  </p>
                  <div className="h-[1px] flex-1 bg-gradient-to-r from-[#b99653]/30 to-transparent"></div>
                </div>
                {item.links.map((link) => (
                  <NavLink
                    to={`${
                      !loginUser.password && link.id === 3
                        ? "/Dashboard/Addpassword"
                        : `/${link.link}`
                    }`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    onMouseEnter={() => setHoveredLink(link.name)}
                    onMouseLeave={() => setHoveredLink(null)}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    <span className="text-lg flex-shrink-0">{link.icon}</span>
                    <span className="capitalize flex-1 text-[14px]">
                      {link.name}
                    </span>
                    {hoveredLink === link.name && (
                      <ChevronRight className="w-3.5 h-3.5 text-[#b99653] group-hover:translate-x-1 transition-transform duration-200" />
                    )}
                  </NavLink>
                ))}
              </div>
            ))}
          </div>

          {/* Footer Section - Logout */}
          <div className="flex-shrink-0 border-t border-gray-200 bg-white/50 backdrop-blur-sm p-3">
            {isLoading ? (
              <div className="flex justify-center items-center py-2.5">
                <ThreeDots
                  color="#b99653"
                  height={28}
                  width={48}
                  timeout={1000000}
                />
              </div>
            ) : (
              <button
                onClick={handleClick2}
                className="w-full flex items-center gap-2.5 px-4 py-2.5 rounded-xl text-[14px] font-semibold text-red-600 hover:bg-red-50 hover:text-red-700 transition-all duration-200 group border-2 border-transparent hover:border-red-200"
              >
                <FiLogOut className="text-lg group-hover:rotate-12 transition-transform duration-200" />
                <span className="capitalize flex-1 text-left">
                  {isAuth ? "Logout" : "Login"}
                </span>
                <ChevronRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
              </button>
            )}

            {/* Footer Info */}
            <div className="mt-2.5 px-2 text-center">
              <p className="text-[9px] text-gray-500 font-medium">
                © 2025 getbrand.gold
              </p>
            </div>
          </div>
        </>
      )}

      {/* Custom Scrollbar Styles */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #b99653, #d4af37);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(to bottom, #d4af37, #b99653);
        }
      `}</style>
    </div>
  );
};

export default Sidebar;
